/**
 * HardwareProviderDevices — the seller's Devices page (left nav).
 *
 * Their fleet in the field: every device built on their boards, the software
 * provider each is connected to, deployed state, and live status. The same
 * table super admins see on a provider's Devices tab, minus cross-links into
 * the company surface.
 */

import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../context/AuthContext';
import { isManufacturerAdmin } from '../services/users';
import { getManufacturer } from '../services/manufacturers';
import { ProviderDeviceFleet } from '../components/ProviderDeviceFleet';
import {
  PageContainer,
  PageHeader,
  PageTitle,
  MutedText,
  LoadingText,
} from '../components/styled';

function HardwareProviderDevices() {
  const { user } = useAuth();
  const manufacturerId = Number(user?.manufacturer_id);

  // Seller-only page; everyone else has richer device surfaces.
  if (!isManufacturerAdmin(user) || !Number.isFinite(manufacturerId)) {
    return <Navigate to="/dashboard" replace />;
  }

  const { data: manufacturer, isLoading } = useQuery({
    queryKey: ['manufacturer', manufacturerId],
    queryFn: () => getManufacturer(manufacturerId),
  });

  if (isLoading) return <PageContainer><LoadingText>Loading devices...</LoadingText></PageContainer>;

  return (
    <PageContainer>
      <PageHeader>
        <div>
          <PageTitle>Devices</PageTitle>
          {manufacturer && (
            <MutedText>{manufacturer.device_count} built on {manufacturer.name} boards</MutedText>
          )}
        </div>
      </PageHeader>
      <ProviderDeviceFleet
        manufacturerId={manufacturerId}
        manufacturerName={manufacturer?.name || 'your'}
        linkThrough={false}
      />
    </PageContainer>
  );
}

export default HardwareProviderDevices;
